import React, { useEffect, useRef } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { Link, useLocation } from "react-router-dom";
export default function StripHeroStoriesContainer(props) {
    var fields = props.fields, children = props.children;
    var pathname = useLocation().pathname;
    var TitleTag = (fields.titleTag || 'h2');
    var splideRef = useRef(null);
    useEffect(function () {
        var links = document.querySelectorAll('[data-splide]');
        links.forEach(function (link) {
            link.addEventListener('click', handleClick);
            link.addEventListener('keydown', handleKeyDown);
        });
        return function () {
            links.forEach(function (link) {
                link.removeEventListener('click', handleClick);
                link.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, []);
    function handleClick(event) {
        var slideIndex = parseInt(event.target.getAttribute('data-splide'));
        splideRef.current.splide.go(slideIndex);
    }
    function handleKeyDown(event) {
        if (event.key === 'Tab' && !event.shiftKey) {
            var slideIndex = parseInt(event.target.getAttribute('data-splide'));
            splideRef.current.splide.go(slideIndex);
        }
    }
    //useEffect(() => {
    //    window.scrollTo(0, 0);
    //}, [pathname]);
    return (React.createElement(Splide, { hasTrack: false, "aria-label": "My Favorite Images", options: {
            rewind: true
            //type: 'loop',
        }, ref: splideRef, className: "strip sky23-featured-carousel splide text-moss container-fluid "
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") },
        React.createElement("div", { className: "row g-0 featured-items-carousel-wrapper", itemScope: true, itemType: "https://schema.org/ItemList" },
            React.createElement("div", { className: "col featured-carousel-caption-col d-flex flex-column align-items-start" },
                React.createElement("div", { className: "featured-items-carousel-caption mb-auto" },
                    fields.displayTitle && React.createElement(TitleTag, { className: "title " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null,
                    fields.content && React.createElement("div", { className: "content", dangerouslySetInnerHTML: { __html: fields.content }, itemProp: "description" }) || null),
                React.createElement("div", { className: "splide__arrows slider-nav" },
                    React.createElement("button", { type: "button", className: "slider-nav-prev splide__arrow splide__arrow--prev btn-with-icon arrow arrow-left text-primary single-icon me-3", "aria-label": "Previous" }),
                    React.createElement("button", { type: "button", className: "slider-nav-next splide__arrow splide__arrow--next btn-with-icon arrow arrow-right text-primary single-icon", "aria-label": "Next" }))),
            React.createElement("div", { className: "col featured-carousel-items-col text-stone" },
                React.createElement(SplideTrack, null, fields && children && children.length > 0 && children.map(function (item, j) {
                    return (React.createElement(SplideSlide, { key: j, itemProp: "itemListElement", itemScope: true, itemType: "https://schema.org/Article" },
                        React.createElement(Link, { "aria-label": "Card" + j, to: item.url ? item.url : "#", title: item.fields.title ? item.fields.title : "", "data-splide": j },
                            React.createElement("div", { className: "splide-card bg-beige justify-content-between p-4 border-radius d-flex flex-column" },
                                item.fields.title && React.createElement("h3", { className: "h2", itemProp: "name" }, item.fields.title) || null,
                                React.createElement("div", { className: "splide-card-body d-flex align-items-end" },
                                    React.createElement("div", { className: "splide-card-text flex-grow-1", dangerouslySetInnerHTML: { __html: item.fields.cardAbstract }, itemProp: "description" }),
                                    React.createElement("div", { className: "splide-card-button" },
                                        " ",
                                        React.createElement("button", { "aria-label": "Food Options", className: "btn btn-with-icon arrow arrow-right", role: "button", title: "Food Options", itemProp: "url" }),
                                        " ")))),
                        React.createElement("meta", { itemProp: "author", content: "Sky Lagoon" })));
                }))))));
}
